import {useEffect} from "react";
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {getPhoneDataFromString} from "@pg-mono/string-utils";

import {useAppSelector} from "../../../store/hooks";
import {initialEmptyApplicationValues} from "../../constants/form/application_form_fields";
import {useMultiLeadRecommendations} from "../../hooks/multi_lead/use_application_multi_lead_recommendations";
import {useLeadRequiredParams} from "../../hooks/use_lead_required_params";
import {hitMultileadRecommendationShown} from "../../tracking/lead/hit_multilead_recommendation_shown";
import {IApplicationData} from "../../types/IApplicationData";
import {MultileadVersion} from "../../types/lead/MultileadVersion";
import {RecommendationSource} from "../../types/lead/RecommendationSource";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {IApplicationMultiLeadSummaryStepState} from "../../types/multi_lead/IApplicationMultiLeadSummaryStepState";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";
import {getSentLeadFormValuesFromStorage} from "../../utils/lead/sent_lead_form_values";
import {ApplicationMultiLead} from "./ApplicationMultiLead";

interface IApplicationMultileadModalStepProps {
    originalApplicationResponse: IApplicationData | null;
    recommendationsWithPriceFilter: boolean;
    roomCount: number;
    isAbroad: boolean;
    recommendationSource: RecommendationSource;
    onNoRecommendations: (originalApplicationResponse: IApplicationData | null) => void;
    onClose: () => void;
    onMultiLeadComplete: (payload: IApplicationMultiLeadSummaryStepState) => void;
}

export const ApplicationMultileadModalStep = (props: IApplicationMultileadModalStepProps) => {
    const {
        originalApplicationResponse,
        recommendationsWithPriceFilter,
        roomCount,
        isAbroad,
        recommendationSource,
        onNoRecommendations,
        onClose,
        onMultiLeadComplete
    } = props;

    const {offerId, propertyId} = useLeadRequiredParams();
    const preventClosingWhenNoData = useAppSelector((state) => state.mainLead.preventClosingWhenNoData);
    const customSourceSection = useAppSelector((state) => state.mainLead.customSourceSection);
    const currentViewType = useAppSelector((store) => store.viewType.current);

    const {areRecommendationsLoading, areRecommendationsEmpty} = useMultiLeadRecommendations({
        propertyId,
        offerId
    });

    useEffect(() => {
        if (areRecommendationsEmpty) {
            const recommendationsType = propertyId ? ApplicationMultiLeadRecommendationType.PROPERTY : ApplicationMultiLeadRecommendationType.OFFER;

            hitMultileadRecommendationShown({
                recommendationType: isAbroad ? recommendationsType : ApplicationMultiLeadRecommendationType.VENDOR,
                recommendationId: null,
                viewType: currentViewType,
                recommendationSource,
                multileadVersion:
                    recommendationsType === ApplicationMultiLeadRecommendationType.PROPERTY ? MultileadVersion.RP_LIST_PROPERTY : MultileadVersion.RP_LIST_OFFER
            });

            onNoRecommendations(originalApplicationResponse);
        }
    }, [areRecommendationsEmpty]);

    if (areRecommendationsLoading) {
        return (
            <div className={multiLeadWrapperStyle}>
                <div className={loaderWrapperStyle}>
                    <Loader />
                </div>
            </div>
        );
    }

    const sentLeadFormValues = getSentLeadFormValuesFromStorage();
    if (!sentLeadFormValues && !preventClosingWhenNoData) {
        onClose();
        return null;
    }

    const originalApplicationFormValues = sentLeadFormValues
        ? {...sentLeadFormValues, phone: getPhoneDataFromString(sentLeadFormValues.phone)}
        : {...initialEmptyApplicationValues, rooms: [roomCount]};

    const recommendationType = propertyId ? ApplicationMultiLeadRecommendationType.PROPERTY : ApplicationMultiLeadRecommendationType.OFFER;

    return (
        <div className={multiLeadWrapperStyle}>
            <ApplicationMultiLead
                originalApplicationResponse={originalApplicationResponse}
                originalApplicationFormValues={originalApplicationFormValues}
                sourceSection={ApplicationSourceSection.MULTILEAD}
                recommendationType={recommendationType}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                disableDefaultSelection
                customSourceSection={customSourceSection || undefined}
                handleModalClose={onClose}
                handleSetMultiLeadSummaryStep={onMultiLeadComplete}
            />
        </div>
    );
};

const multiLeadWrapperStyle = css({
    height: "100%",
    md: {
        width: "950px",
        height: "auto"
    }
});

const loaderWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    md: {
        height: "40rem"
    }
});
import {useEffect} from "react";
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {getPhoneDataFromString} from "@pg-mono/string-utils";

import {useAppSelector} from "../../../store/hooks";
import {initialEmptyApplicationValues} from "../../constants/form/application_form_fields";
import {useMultiLeadRecommendations} from "../../hooks/multi_lead/use_application_multi_lead_recommendations";
import {useLeadRequiredParams} from "../../hooks/use_lead_required_params";
import {hitMultileadRecommendationShown} from "../../tracking/lead/hit_multilead_recommendation_shown";
import {IApplicationData} from "../../types/IApplicationData";
import {MultileadVersion} from "../../types/lead/MultileadVersion";
import {RecommendationSource} from "../../types/lead/RecommendationSource";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {IApplicationMultiLeadSummaryStepState} from "../../types/multi_lead/IApplicationMultiLeadSummaryStepState";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";
import {getSentLeadFormValuesFromStorage} from "../../utils/lead/sent_lead_form_values";
import {ApplicationMultiLead} from "./ApplicationMultiLead";

interface IApplicationMultileadModalStepProps {
    originalApplicationResponse: IApplicationData | null;
    recommendationsWithPriceFilter: boolean;
    roomCount: number;
    isAbroad: boolean;
    recommendationSource: RecommendationSource;
    onNoRecommendations: (originalApplicationResponse: IApplicationData | null) => void;
    onClose: () => void;
    onMultiLeadComplete: (payload: IApplicationMultiLeadSummaryStepState) => void;
}

export const ApplicationMultileadModalStep = (props: IApplicationMultileadModalStepProps) => {
    const {
        originalApplicationResponse,
        recommendationsWithPriceFilter,
        roomCount,
        isAbroad,
        recommendationSource,
        onNoRecommendations,
        onClose,
        onMultiLeadComplete
    } = props;

    const {offerId, propertyId} = useLeadRequiredParams();
    const preventClosingWhenNoData = useAppSelector((state) => state.mainLead.preventClosingWhenNoData);
    const customSourceSection = useAppSelector((state) => state.mainLead.customSourceSection);
    const currentViewType = useAppSelector((store) => store.viewType.current);

    const {areRecommendationsLoading, areRecommendationsEmpty} = useMultiLeadRecommendations({
        propertyId,
        offerId
    });

    useEffect(() => {
        if (areRecommendationsEmpty) {
            const recommendationsType = propertyId ? ApplicationMultiLeadRecommendationType.PROPERTY : ApplicationMultiLeadRecommendationType.OFFER;

            hitMultileadRecommendationShown({
                recommendationType: isAbroad ? recommendationsType : ApplicationMultiLeadRecommendationType.VENDOR,
                recommendationId: null,
                viewType: currentViewType,
                recommendationSource,
                multileadVersion:
                    recommendationsType === ApplicationMultiLeadRecommendationType.PROPERTY ? MultileadVersion.RP_LIST_PROPERTY : MultileadVersion.RP_LIST_OFFER
            });

            onNoRecommendations(originalApplicationResponse);
        }
    }, [areRecommendationsEmpty]);

    if (areRecommendationsLoading) {
        return (
            <div className={multiLeadWrapperStyle}>
                <div className={loaderWrapperStyle}>
                    <Loader />
                </div>
            </div>
        );
    }

    const sentLeadFormValues = getSentLeadFormValuesFromStorage();
    if (!sentLeadFormValues && !preventClosingWhenNoData) {
        onClose();
        return null;
    }

    const originalApplicationFormValues = sentLeadFormValues
        ? {...sentLeadFormValues, phone: getPhoneDataFromString(sentLeadFormValues.phone)}
        : {...initialEmptyApplicationValues, rooms: [roomCount]};

    const recommendationType = propertyId ? ApplicationMultiLeadRecommendationType.PROPERTY : ApplicationMultiLeadRecommendationType.OFFER;

    return (
        <div className={multiLeadWrapperStyle}>
            <ApplicationMultiLead
                originalApplicationResponse={originalApplicationResponse}
                originalApplicationFormValues={originalApplicationFormValues}
                sourceSection={ApplicationSourceSection.MULTILEAD}
                recommendationType={recommendationType}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                disableDefaultSelection
                customSourceSection={customSourceSection || undefined}
                handleModalClose={onClose}
                handleSetMultiLeadSummaryStep={onMultiLeadComplete}
            />
        </div>
    );
};

const multiLeadWrapperStyle = css({
    height: "100%",
    md: {
        width: "950px",
        height: "auto"
    }
});

const loaderWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    md: {
        height: "40rem"
    }
});
